import { WEBSITE_URL } from 'core-lib/data/common';
import Head from 'next/head';
import { useRouter } from 'next/router';

type SchemaGeneratorProps = {
  e: any;
  data: any;
  params: any;
};

const SchemaGenerator = ({ e, data, params }: SchemaGeneratorProps) => {
  const schemaObj = {};
  schemaObj[`@context`] = 'https://schema.org';
  schemaObj[`@type`] = `${e?.schemaType}`;
  if (e.schemaType === 'SiteNavigationElement') {
    schemaObj['name'] = `${data?.slug}`;
    schemaObj['url'] = `${data?.seo?.canonical_url}`;
  } else if (e.schemaType === 'Article') {
    schemaObj['name'] = data?.seo?.meta_title;
    schemaObj['url'] = data?.seo?.canonical_url;
    schemaObj['articleSection'] = `${data?.slug}`;
    schemaObj['description'] = data?.seo?.meta_description;
  } else if (e.schemaType === 'Table') {
    const schemaObj = JSON.parse(e?.data);
    return schemaObj;
  } else if (e.schemaType === 'FAQPage') {
    schemaObj['mainEntity'] = (
      data?.faq?.faq ||
      data?.Faqs?.faq ||
      data?.faqs?.faq ||
      data.faq
    ).map((e: any) => ({
      '@type': 'Question',
      name: `${e?.question}`,
      acceptedAnswer: { '@type': 'Answer', text: `${e?.answer}` },
    }));
  } else if (e.schemaType == 'FinancialProduct') {
    (schemaObj['name'] = `${data?.flexibleArticleCategory?.slug}`),
      (schemaObj['url'] = `${data?.seo?.canonical_url}`),
      (schemaObj['brand'] = { '@type': 'Thing', name: `${params}` });
  } else {
    const schemaObj = JSON.parse(e?.data);
    return schemaObj;
  }
  return schemaObj;
};

type SeoProps = {
  data: any;
  canonicalisedUrl?: any;
};

const SeoData = ({ data, canonicalisedUrl }: SeoProps) => {
  const router = useRouter();
  const params = router.query.slug || router.query.dynamic_url;
  return (
    <Head>
      <title>{data?.seo?.meta_title || data?.seoTitle}</title>
      <meta
        name="description"
        content={data?.seo?.meta_description || data?.seoDescription}
      />
      {data?.seoKeywords && (
        <meta name="keywords" content={data?.seoKeywords} />
      )}
      {(/f\/.*fastag-recharge/i.test(router?.asPath) ||
        router?.query?.params === 'fastag-recharge') && (
        <link
          rel="alternate"
          href="android-app://com.ovunque.parkwheels/parkplus/app?src=fastag_recharge"
        />
      )}
      {router?.query?.slug?.includes('challan') && (
        <link
          rel="alternate"
          href={`android-app://com.ovunque.parkwheels/parkplus/app?src=challan&url=https://parkplus.io${router.asPath}&web_title=Challan Information`}
        />
      )}
      {router?.pathname?.includes('new-cars') && (
        <link
          rel="alternate"
          href={`android-app://com.ovunque.parkwheels/parkplus/app?src=new_cars&url=https://parkplus.io${router?.asPath}&web_title=New cars`}
        />
      )}

      <link
        rel="canonical"
        href={
          canonicalisedUrl
            ? canonicalisedUrl
            : data?.seo?.canonical_url ||
              data?.seoCanonicalUrl ||
              `${WEBSITE_URL}${router.asPath}`
        }
      />

      {(data?.seo?.should_index || data?.seoShouldIndex) && (
        <meta name="robots" content="index, follow, max-image-preview:large" />
      )}
      {(data?.seo?.should_index || data?.seoShouldIndex) === false ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : null}
      {data?.schema ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(data?.schema),
          }}
        />
      ) : null}
      {data?.seo?.schemaMarkup?.map((e: any) => (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(SchemaGenerator({ e, data, params })),
          }}
        />
      ))}
    </Head>
  );
};

export default SeoData;
